import { Context } from '@/models/order-history/status/context/context'
import { CreateStateCommandForExternalPayment } from '@spa/components/organisms/mypage/order/model/reorder-acceptability-state/for-external-payment'
import { CreateStateCommandForNpPostpay } from '@spa/components/organisms/mypage/order/model/reorder-acceptability-state/for-np-postpay'

/**
 * 再注文受け付け可否を表す状態
 */
export type ReorderAcceptabilityState = ReorderAcceptableState | typeof reorderNotAcceptableState

interface ReorderAcceptableState {
  id: string // 主にテスト用で表示には利用しない
  acceptable: true
  createReorderPath: (orderId: string) => string
  view: {
    buttonLabel: string
    description: string[]
    title?: string
  }
}

export const reorderNotAcceptableState = {
  id: 'not-acceptable',
  acceptable: false,
  createReorderPath: () => undefined,
}

export function reorderIsAcceptable(state: ReorderAcceptabilityState): state is ReorderAcceptableState {
  return state.acceptable
}

export function getReorderAcceptabilityState(
  context: Pick<Context, 'engineStatus' | 'historyErrorList' | 'paymentType'>
): ReorderAcceptabilityState {
  const commandForNpPostpay = new CreateStateCommandForNpPostpay()
  if (commandForNpPostpay.shouldApply(context)) {
    return commandForNpPostpay.execute(context)
  }
  const commandForExternalPayment = new CreateStateCommandForExternalPayment()
  if (commandForExternalPayment.shouldApply(context)) {
    return commandForExternalPayment.execute(context)
  }

  return reorderNotAcceptableState
}
